import React from 'react';
import { useTranslation } from 'react-i18next';
import './Analytics.css';

function AdAnalytics({ product }) {
  const { t } = useTranslation();
  const stats = product?.stats || {};
  const views = Number(stats.views) || 0;
  const favorites = Number(stats.favorites) || 0;
  const messages = Number(stats.messages) || 0;
  const offers = Number(stats.offers) || 0;

  return (
    <div className="adAnalytics">
      <h3>{t('analytics.adPerformance')}</h3>
      <div className="adAnalyticsGrid">
        <div className="adAnalyticsCard">
          <span className="adAnalyticsValue">{views}</span>
          <span className="adAnalyticsLabel">{t('analytics.views')}</span>
        </div>
        <div className="adAnalyticsCard">
          <span className="adAnalyticsValue">{favorites}</span>
          <span className="adAnalyticsLabel">{t('analytics.favorites')}</span>
        </div>
        <div className="adAnalyticsCard">
          <span className="adAnalyticsValue">{messages}</span>
          <span className="adAnalyticsLabel">{t('analytics.messages')}</span>
        </div>
        <div className="adAnalyticsCard">
          <span className="adAnalyticsValue">{offers}</span>
          <span className="adAnalyticsLabel">{t('analytics.offers')}</span>
        </div>
      </div>
    </div>
  );
}

export default AdAnalytics;
